import { Badge } from 'src/design/atoms/Badge';
import { Group } from 'src/design/atoms/Group';
import { Paper } from 'src/design/atoms/Paper';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import React from 'react';
import { useAuth } from 'src/hooks/useAuth';
import { TagBadgeList } from 'src/design/molecules/TagBadgeList';
import { Header } from 'src/design/organisms/Header';

export const Permissions: React.FC = () => {
  const { scopes, user } = useAuth();

  const renderRoles = () => {
    return (
      <Group gap="xs">
        {user?.userOrganizationRole?.map((ur) => (
          <Badge key={ur.organizationRole?.id} variant="light" color="blue">
            {ur.organizationRole?.name}
          </Badge>
        ))}
      </Group>
    );
  };

  const renderOffices = () => {
    return (
      <Group gap="xs">
        {user?.userOrganizationOffice?.map((uo) => (
          <Badge key={uo.organizationOffice?.id} variant="light" color="blue">
            {uo.organizationOffice?.name}
          </Badge>
        ))}
      </Group>
    );
  };

  return (
    <>
      <Header
        title="Permissions"
        breadcrumbProps={{
          items: [{ text: 'Account' }, { text: 'Permissions' }],
        }}
        helpText={'View your account permissions.'}
      />
      <Paper p="md" mt="md">
        <Stack gap="md">
          <div>
            <Text size="sm" mb="xs">
              Roles
            </Text>
            {renderRoles()}
          </div>
          <div>
            <Text size="sm" mb="xs">
              Scopes
            </Text>
            <TagBadgeList tags={scopes} maxItems={6} />
          </div>
          <div>
            <Text size="sm" mb="xs">
              Offices
            </Text>
            {renderOffices()}
          </div>
        </Stack>
      </Paper>
    </>
  );
};
